<template>
  <v-dialog
      v-model="showWindow"
      scrollable
      max-width="1000"
      max-height="90%"
      min-width="600px"
      persistent
  >
    <v-card height="100%" :loading="!isFetchedOrder">
      <v-card-actions>
        <h3 class="pl-2" id="bidWindow">
          {{ $t('payments.finance') }}
        </h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="showWindow = false">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-text class="pa-4" v-if="order && order.id">

        <v-tabs v-model="tabId" slider-color="accent">
          <v-tab ripple>
            {{ $t("payments.pay_a_fee_title") }}
          </v-tab>
          <v-tab ripple>
            {{ $t('costs.additional_title') }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabId">
          <v-tab-item>
            <v-card flat class="mt-5">
              <v-list class="pa-0 mb-2" >
                <v-list-item
                    class="pa-0 grey lighten-3 rounded-sm px-3 mb-1"
                    :class="{'lighten-3':!$vuetify.theme.dark, 'darken-3':$vuetify.theme.dark}"
                    v-for="item in order.payments"
                    :key="item.id"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="formatCurrency(item.value)"></v-list-item-title>
                    <v-list-item-subtitle>{{ paymentName(item) }}</v-list-item-subtitle>
                    <v-list-item-subtitle>
                      {{ item.created_at | moment("DD.MM.YYYY HH:mm") }}
                    </v-list-item-subtitle>

                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn icon color="red" @click="deletePayment(item)" :title="$t('common.remove')">
                      <v-icon x-small color="red" text-color="red">fa-trash</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <v-form ref="payment" class="w-100">
                <v-select
                    xs6
                    :items="filteredPaymentsTypes"
                    :label="$t('payments.type')"
                    item-text="name"
                    return-object
                    :rules="[(v) => !!v || $t('form.validationErrors.field_is_required')]"
                    v-model="order_payment.type"
                    outlined
                >
                  <template v-slot:selection="{ item }">
                    {{ $t("payments.types." + item.name) }}
                  </template>
                  <template v-slot:item="{ item }">
                    {{ $t("payments.types." + item.name) }}
                  </template>
                </v-select>
                <v-text-field
                    type="number"
                    :placeholder="$t('payments.value')"
                    :rules="[
            (v) => !!v || $t('form.validationErrors.field_is_required'),
            (v) => v >= 1 || $t('form.validationErrors.must_be_greater', [0]),
          ]"
                    hide-details
                    v-model="order_payment.value"
                    outlined
                ></v-text-field>
                <v-divider class="my-5"></v-divider>
                <div class="text-right">
                  <v-btn
                      class="mt-0 white--text"
                      color="primary"
                      elevation="0"
                      @click="addPayment"
                      @keyup.enter="addPayment"
                      :disabled="!fetched || savingInProgress"
                      :loading="!fetched || savingInProgress"
                  >
                    {{ $t("payments.pay_a_fee") }}
                  </v-btn>
                </div>
              </v-form>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat class="mt-5">
              <v-list class="pa-0 mb-2" >
                <v-list-item
                    class="pa-0 grey lighten-3 rounded-sm px-3 mb-1"
                    :class="{'lighten-3':!$vuetify.theme.dark, 'darken-3':$vuetify.theme.dark}"
                    v-for="item in order.costs"
                    :key="item.id"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="formatCurrency(item.value)"></v-list-item-title>
                    <v-list-item-subtitle v-text="$t('costs.types.'+item.cost_type.name)"></v-list-item-subtitle>
                    <v-list-item-subtitle v-text="item.comment"></v-list-item-subtitle>
                    <v-list-item-subtitle>
                      {{ item.created_at | moment("DD.MM.YYYY HH:mm") }}
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn icon color="red" @click="deleteCost(item)" :title="$t('common.remove')">
                      <v-icon x-small color="red" text-color="red">fa-trash</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>

                <v-form ref="cost" xs12 class="w-100">
                  <v-select
                      outlined
                      :items="costTypes"
                      :label="$t('costs.type')"
                      item-text="name"
                      return-object
                      :rules="[(v) => !!v || $t('form.validationErrors.field_is_required')]"
                      v-model="cost.type"
                  >
                    <template v-slot:selection="{item}">
                      {{ $t('costs.types.' + item.name) }}
                    </template>
                    <template v-slot:item="{item}">
                      {{ $t('costs.types.' + item.name) }}
                    </template>
                  </v-select>
                  <v-text-field
                      outlined
                      type="number"
                      :placeholder="$t('costs.value')"
                      :rules="[(v) => !!v || $t('form.validationErrors.field_is_required'), (v) => (v>=1) || $t('form.validationErrors.must_be_greater', [0])]"
                      v-model="cost.value"
                  ></v-text-field>
                  <v-text-field
                      outlined
                      :placeholder="$t('common.comment')"
                      hide-details
                      v-model="cost.comment"
                  ></v-text-field>
                  <v-divider class="mt-5"></v-divider>
                  <div class="text-right">
                    <v-btn
                        :disabled="isCostSaving"
                        :loading="isCostSaving"
                        class="mt-5 white--text"
                        color="primary"
                        elevation="0"
                        @click="addCost"
                        @keyup.enter="addCost"
                    >
                      {{ $t('common.add') }}
                    </v-btn>
                  </div>
                </v-form>

            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import CommonMixin from "@/mixins/common";
import {mapFields} from "vuex-map-fields";

export default {
  name: "OrderFinanceWindow",
  mixins: [CommonMixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    order_id: null
  },
  data: () => ({
    tabId: 0,
    order: null,
    order_payment: {
      value: null,
      type: null,
      order_id: null
    },
  }),
  computed:{
    ...mapFields('costs', ['costTypes', 'fetched', 'cost', 'isCostSaving']),
    ...mapFields("site", ["lang"]),
    ...mapFields("payments", ["paymentsTypes", "fetched", "savingInProgress"]),
    ...mapFields("orders", ["isFetchedOrder"]),
    filteredPaymentsTypes(){
      return this.paymentsTypes.filter(item=>{
        return (item.available_in_lang ==='*' || item.available_in_lang === this.lang )
      })
    },
    showWindow: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("hide");
      },
    },
  },
  watch:{
    order(to){
      if(to && to.id){
        this.$nextTick(()=>{
          if(this.tabId==0) {
            this.$refs['payment'].reset();
          } else {
            this.$refs['cost'].reset();
          }
        })
      }
    },
    showWindow(to){
      if(to){
        this.onLoad();
      } else {
        this.order = null;
      }
    }
  },
  methods: {
    paymentName(item){
      let  name;
      this.paymentsTypes.forEach((el)=>{
        if(parseInt(el.id) === parseInt(item.payment_system_type_id)){
          name = this.$t("payments.types." + el.name)
        }
      })
      return name
    },
    addPayment() {
      if (this.$refs["payment"].validate()) {
        this.order_payment.order_id = this.order.id;
        this.$store.dispatch("payments/addPayment", this.order_payment).then((res) => {
          if (res) {
            this.$refs['payment'].reset();
            this.onLoad();
          }
        });
      }
    },
    deleteCost(item) {
      this.$store.dispatch('costs/deleteCost', item).then((res)=>{
        this.onLoad()
      })
    },
    deletePayment(item) {
      this.$store.dispatch('payments/deletePayment', item).then((res)=>{
        this.onLoad()
      })
    },
    addCost() {
      if (this.$refs['cost'].validate()) {
        this.cost.order_id = this.order.id;
        this.$store.dispatch('costs/costStore', this.cost).then((res) => {
          if (res) {
            this.$refs['cost'].reset();
            this.onLoad();
          }
        })
      }
    },
    async onLoad() {
      this.order = await this.$store.dispatch("orders/orderShow", {
        id: this.order_id
      });
      this.$store.dispatch("payments/getPaymentTypes", { type: "all" });
      this.$store.dispatch('costs/getCostsTypes');
    },
  },
}
</script>

<style scoped>

</style>